import React, { Fragment, useEffect } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { changeToDelivered, getOrder } from '../../actions/ordersActions'
import Swal from 'sweetalert2'

export default function Order() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const {id} = useParams()
    const navigate = useNavigate()

	const {order, resultorder} = useSelector(state=>state.orders)

	useEffect(() => {
		if(client){
			dispatch(getOrder(id))
		}
	},[dispatch, t, client, id])

    useEffect(()=>{
        if (order) {
            
        }
    }, [order])

    const setOrderDelivered = async(e, idOrder) => {
        e.preventDefault()

		dispatch(changeToDelivered(idOrder, 'kitchen'))
	}

    useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'changedsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.orders.changedsuccess')
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/kitchen/dashboard')
                        }
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/kitchen/dashboard">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.orders.ordersfordelivery')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
                <label className='sd-label-medium'>{t('admin.orders.order')} {order?.orderReference}</label>
            </Row>
			{order
				?
					<>
						<Row className="text-start my-3">
							- {t('admin.orders.client')}: {order?.user}<br/>
							- {t('admin.orders.restaurant')}: {order?.restaurant}<br/>
							- {t('admin.orders.hour')}: {order?.hour+' ('+order?.date?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)+')'}<br/>
							- {t('admin.orders.orderat')}: {order?.orderAt?.substr(11,5)+' ('+order?.orderAt?.substr(8,2)+'/'+order?.orderAt?.substr(5,2)+'/'+order?.orderAt?.substr(0,4)+')'}<br/>
							- {t('admin.orders.firstdish')}: {order?.firstdish?.name}<br/>
							- {t('admin.orders.seconddish')}: {order?.seconddish?.name}<br/>
							- {t('admin.orders.drink')}: {order?.drink?.name}<br/>
							- {t('admin.orders.dessert')}: {order?.dessert?.name}<br/>
							{order?.complements?.length > 0 ?
									<Fragment>
										- {t('admin.orders.complements')}: 
										{order?.complements?.map((complement, index) =>(
											<Fragment key={index}>- {complement?.name}<br/></Fragment>
										))}
									</Fragment>
								:
									<></>
							}
						</Row>
						{!order?.isDelivered
							?
								<Row className="text-start my-3">
									<Button type="button" className="btn-primary my-2 w-100" onClick={(e) => setOrderDelivered(e, order?._id)}>
										<label className='label-button'>{t('admin.orders.changetodelivered')}</label>
									</Button>
								</Row>
							:
								<Fragment>
									<h1>{t('kitchen.orders.orderdelivered')}</h1>
								</Fragment>
						}
					</>
				:
					<></>
			}
        </Container>
	)
}